import { ErrorBoundary } from "react-error-boundary";
import { memo, useCallback, useState } from "react";

import DropdownLabel from "components/Organisms/DatasetsMenu/DatabaseDropdown/DropdownLabel";
import DropdownChildren from "components/Organisms/DatasetsMenu/DatabaseDropdown/DropdownChildren";
import { StyledWrapper } from "components/Organisms/DatasetsMenu/DatabaseDropdown/styles";
import { CustomError } from "components/Atoms/GeneralError/GeneralError";

interface DatabaseDropdownProps {
  displayName: string;
  id: string;
}

const DatabaseDropdown = memo(({ displayName, id }: DatabaseDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = useCallback(() => {
    setIsOpen((prev) => {
      return !prev;
    });
  }, [setIsOpen]);

  return (
    <StyledWrapper>
      <DropdownLabel id={id} open={isOpen} name={displayName} toggle={toggle} />

      <ErrorBoundary
        FallbackComponent={CustomError("Not tables found for this database")}>
        {isOpen && <DropdownChildren open={isOpen} databaseId={id} />}
      </ErrorBoundary>
    </StyledWrapper>
  );
});

export default DatabaseDropdown;
